import {
  fetchUserReplyTemplates,
  type TUserReplyTemplatesResponse,
} from '../../repositories/chats/v1/user-reply-templates';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

import type { IApplicationContext } from '../../types/applicationContext';
import type { FetchResponse } from '@cian/http-api';

const DEFAULT_ERROR_MESSAGE = 'Ошибка получения списка шаблонов ответов';

export async function fetchUserReplyTemplatesPublic(context: IApplicationContext) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: FetchResponse<TUserReplyTemplatesResponse> = await fetchUserReplyTemplates({
      httpApi,
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.ReplyTemplates,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return response;
  } catch (e) {
    const exception = getGenericLikeError({
      error: e,
      domain: EExceptionDomain.ReplyTemplates,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/user-reply-templates/',
    });

    throw exception;
  }
}
